var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSocialGmail = function SvgIconSocialGmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M2.403 16.668h2.79V9.895L1.207 6.906v8.567c0 .661.536 1.195 1.195 1.195M14.755 16.668h2.789c.661 0 1.195-.536 1.195-1.195V6.906l-3.984 2.989"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M14.755 4.714v5.18l3.984-2.988V5.312c0-1.478-1.687-2.32-2.869-1.434M5.192 9.895v-5.18L9.974 8.3l4.781-3.586v5.18L9.974 13.48M1.208 5.312v1.594l3.984 2.988v-5.18l-1.115-.836c-1.184-.887-2.869-.044-2.869 1.434"
  })));
};
export default SvgIconSocialGmail;